import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  getRenterListingQualifications,
  getRenterFacingQualificationsCopy,
  LISTING_QUALIFICATION_PETS_ZERO,
} from 'common/householdApplication/prequalificationHelpers';
import {
  LISTING_DATA_SOURCE_SMART_APARTMENT,
} from 'common/listingConstants';

import SrBatteryMessage from 'client/components/SrBatteryMessage';

class SrListingQualificationsCard extends Component {
  static propTypes = {
    renterProfile: PropTypes.object.isRequired,
    listing: PropTypes.object.isRequired,
    showQualifiedCardPrompt: PropTypes.bool,
  }

  render() {
    const { renterProfile, listing, showQualifiedCardPrompt, onClickScrollDownButton } = this.props;
    const renterListingQualifications = getRenterListingQualifications(renterProfile, listing);
    const renterFacingQualificationsCopy = renterListingQualifications
      && getRenterFacingQualificationsCopy(renterProfile, listing);

    return (
      <div className='qualificationsCard'>
        <div className='textContainer'>
          <div className='qualificationRow'>
            <SrBatteryMessage
              message={renterFacingQualificationsCopy.priceQualification.copy}
              tooltipCopy={renterFacingQualificationsCopy.priceQualification.tooltipCopy}
              isNegative={!renterFacingQualificationsCopy.priceQualification.isQualified}
              flipTooltip
            />
          </div>
          {listing.dataSource !== LISTING_DATA_SOURCE_SMART_APARTMENT && (
            <div className='qualificationRow'>
              <SrBatteryMessage
                message={renterFacingQualificationsCopy.availableDateQualification.copy}
                tooltipCopy={renterFacingQualificationsCopy.availableDateQualification.tooltipCopy}
                isNegative={!renterFacingQualificationsCopy.availableDateQualification.isQualified} // eslint-disable-line max-len
                flipTooltip
              />
            </div>
          )}
          {renterListingQualifications.pets !== LISTING_QUALIFICATION_PETS_ZERO && (
            <div className='qualificationRow'>
              <SrBatteryMessage
                message={renterFacingQualificationsCopy.petsQualification.copy}
                tooltipCopy={renterFacingQualificationsCopy.petsQualification.tooltipCopy}
                isNegative={!renterFacingQualificationsCopy.petsQualification.isQualified}
                flipTooltip
              />
            </div>
          )}
        </div>
        {showQualifiedCardPrompt && (
          <div className='promptContainer'>
            <div className='badge' />
            <div className='promptTextContainer'>
              <span className='qualified'>you’re qualified to rent it!</span>
              <span className='request'>
                <span
                  className='clickToScroll'
                  onClick={onClickScrollDownButton}
                >
                  {listing.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT
                    ? 'Check availability'
                    : 'Request a tour'
                  }
                </span> below
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

SrListingQualificationsCard.displayName = 'SrListingQualificationsCard';

export default SrListingQualificationsCard;
